// extracted by mini-css-extract-plugin
export default {"relative":"Oai1SbnR","list":"hboSA3g2","pinned":"KvLiXELc"};